var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

import Vue from 'vue'
import store from '../../vuex/store'
import axios from 'axios'
const $util = {
    uploadOSS(param){
        return new Promise((resolve, reject) => {
            let base64 = param.base64;
            $util.post(store.state.common.root + 'com/getOssStsToken').then((res) => {
                let isHttps = window.location.origin.indexOf('https') > -1;
                let http = isHttps ? 'https://' : '';
                let secure = isHttps ? true : undefined;
                let data = res.data;
                let client = new OSS.Wrapper({
                    accessKeyId : data.access_key_id,
                    accessKeySecret : data.access_key_secret,
                    bucket : data.bucket_name,
                    stsToken: data.security_token,
                    secure: secure,
                    endpoint: http + data.endpoint
                });
                let suffix = param.suffix || '.jpg';
                let obj = param.name || $util.$_OSS.timestamp();  // 这里是生成文件名
                //console.log(suffix, obj)
                //return;

                let blob = $util.$_img.base64ToBlob(base64); //blob
                let storeAs = data.upload_file_path + obj + suffix;  //命名空间
                //console.log(' => ' + storeAs);

                // blob转arrayBuffer
                let reader = new FileReader();
                reader.readAsArrayBuffer(blob);
                reader.onload = (event)=>{
                    // arrayBuffer转Buffer
                    let buffer = new OSS.Buffer(event.target.result);
                    //multipartUpload
                    client.put(storeAs, buffer).then(result => {
                        //console.log(result); //--->返回对象
                        //console.log(result.url); //--->返回链接
                        let h = result.url.indexOf('https://') > -1 ? 'https://' : 'http://';
                        let tempStr = h + data.bucket_name + '.' + data.endpoint;
                        let url = result.url.replace(tempStr, data.cdn);
                        resolve(url);
                    }).catch(err => {
                        //console.log(err);
                        reject();
                    }).then(()=>{
                        reject();
                    });
                }
            }, err => {
                reject();
            })
        })
    },
    $_OSS: {
        add0(m){
            return m<10?'0'+m : m;
        },
        timestamp(){
            let time = new Date();
            let y = time.getFullYear();
            let m = time.getMonth()+1;
            let d = time.getDate();
            let h = time.getHours();
            let mm = time.getMinutes();
            let s = time.getSeconds();
            return ""+y+$util.$_OSS.add0(m)+$util.$_OSS.add0(d)+$util.$_OSS.add0(h)+$util.$_OSS.add0(mm)+$util.$_OSS.add0(s);
        }
    },
    /**
     * 图片处理
     */
    $_img: {
        // base64转成bolb对象
        base64ToBlob(base64Data) {
            let byteString;
            if (base64Data.split(",")[0].indexOf("base64") >= 0)
                byteString = atob(base64Data.split(",")[1]);
            else byteString = unescape(base64Data.split(",")[1]);
            let mimeString = base64Data
                .split(",")[0]
                .split(":")[1]
                .split(";")[0];
            let ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], { type: mimeString });
        },
        // blob对象转成blob链接
        blobToUrl(blob){
            return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
        },
        // base64转成blob链接
        base64ToUrl(base64Data){
            return $util.$_img.blobToUrl($util.$_img.base64ToBlob(base64Data));
        },
        fileToUrl(file){
            let url = null;
            if (window.createObjectURL!=undefined) { // basic
                url = window.createObjectURL(file) ;
            } else if (window.URL!=undefined) { // mozilla(firefox)
                url = window.URL.createObjectURL(file) ;
            } else if (window.webkitURL!=undefined) { // webkit or chrome
                url = window.webkitURL.createObjectURL(file) ;
            }
            return url ;
        },
        // base64转成image对象
        base64ToImage(base64Data) {
            return new Promise(function(resolve, reject) {
                let image = new Image();
                image.crossOrigin = 'anonymous';//解决跨域问题，需在服务器端运行，可选值：anonymous，*

                image.onload = ()=>{
                    let canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    let ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    let base64Url = canvas.toDataURL();
                    resolve({
                        base64: base64Url,
                        width: image.width,
                        height: image.height
                    });
                };

                image.onerror = function() {
                    reject(new Error('图片加载错误，请稍后再试！'));
                };

                image.src = base64Data;
            });
        },
        compressImg(param = {}){
            return new Promise(function(resolve, reject) {
                let url = param.url;
                let image = new Image();
                let isCompress = false;
                let base64 = '';
                image.crossOrigin = 'anonymous';//解决跨域问题，需在服务器端运行，可选值：anonymous，*

                image.onload = ()=>{
                    let maxWidth = param.maxWidth || 1000;

                    let canvas = document.createElement('canvas');
                    canvas.width = maxWidth;
                    canvas.height = maxWidth * image.height / image.width;
                    let ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

                    if(image.width <= maxWidth){
                        if(url.indexOf(';base64') > -1){
                            base64 = url;
                            url = $util.$_img.base64ToUrl(base64);
                        }else{
                            base64 = canvas.toDataURL();
                        }
                        return resolve({
                            base64: base64,
                            url: url,
                            isCompress: isCompress,
                            width: image.width,
                            height: image.height
                        });
                    }
                    base64 = canvas.toDataURL();
                    url = $util.$_img.base64ToUrl(base64);
                    isCompress = true;
                    return resolve({
                        base64: base64,
                        url: url,
                        isCompress: isCompress,
                        width: canvas.width,
                        height: canvas.height
                    });
                };

                image.onerror = function() {
                    reject(new Error('图片加载错误，请稍后再试！'));
                };

                image.src = url;
            });
        }
    },
    //【ajax】
    post(url, para, opts){
        return $util.axios('post', url, para, opts);
    },
    get(url, para, opts){
        return $util.axios('get', url, para, opts);
    },
    source: null,
    axios(method, url, para, opts){
        opts = opts || {
            isTip: true
        }
        /*var CancelToken = self.$ajax.CancelToken;
        this.source = CancelToken.source();*/

        var time = 0;
        var cons = false;
        return new Promise((resolve, reject) => {
            let style = 'font-size:14px;font-weight:bold;';
            setTimeout(()=>{
                let objPara = {
                    method,
                    url,
                    data: para,
                    timeout: 8000,
                    //cancelToken: this.source.token
                }
                if(method == 'get'){
                    objPara.params = para;
                    delete objPara['data'];
                };
                axios(objPara).then(response=> {
                    //console.log(response)
                    if(cons){console.log('%c请求成功','color:#33941f;' + style);}
                    let data = (response && response.data) || null;
                    if(data && !data.headers) data.headers = response.headers;
                    if (!data || !data.is_ok) {
                        //跳过then
                        reject(data);
                        if(cons){console.log(data);}
                        return false;
                    }
                    //继续then
                    resolve(data);
                    if(cons){console.log(data);}
                }, err=> {
                    if(cons){console.dir(err);}
                    let data = err.data || (err.response && err.response.data);
                    //跳过then
                    //if(data && data.error_code == 500) data.error = 'error';
                    if(data && !data.headers && (typeof data == 'object')) data.headers = err.headers;
                    reject(data);
                    if(opts.isTip){
                        Vue.$vux.toast.text((data && data.error && data.error.length < 60) ? data.error : '网络异常，请稍后再试', 'top');
                    }
                    if(cons){
                        console.log(err);
                        console.log('%c请求失败！','color:red;' + style);
                    }
                })
            }, time)
        });
    },

    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        },


      /*
       * 秒到时间格式
       * time--时间戳
       * */
      secondToTime(time){
        let days = parseInt(time / 60 / 60 / 24), //计算剩余的天数
          hours = parseInt(time / 60 / 60 % 24), //计算剩余的小时
          minutes = parseInt(time / 60 % 60),//计算剩余的分钟
          seconds = parseInt(time % 60);//计算剩余的秒数
        let d = days > 0 ? days + '天' : '',
          h = hours > 0 ? hours + '小时' : '',
          m = minutes > 0 ? minutes + '分' : '',
          s = seconds > 0 ? seconds + '秒' : '';
        return d + h + m + s;
      },
      /*
       * 时间戳到时间格式
       * time--时间戳
       * */
      stampToTime(time, delimiter){
        time = time || null;
        delimiter = delimiter || '-';
        let date = new Date(time);
        let y = date.getFullYear(), //年
            m = date.getMonth() + 1, //月
            d = date.getDate();//日
        m = m < 10 ? '0' + m : m;
        d = d < 10 ? '0' + d : d;
        let res = y + delimiter + m + delimiter + d;
        return res;
      },

    },
    /*
     * form提交格式（数组_转name,value提交格式）
     * key
     * value
     * */
    formKeyValue(arr, name){
        return arr.map(function(item){
            return {
                name: name,
                value: item
            }
        });
    },

    /*
    * 对象转成数组提交（对象_转name,value提交格式）
    * 转前 obj = {key : 'value'}
    * 转后 arr = [{name: 'key', value: 'value'}]
    * */
    objToArrSub(obj){
        let tempArr = [];
        for(let key in obj){
            tempArr.push({
                name: key,
                value: obj[key],
            });
        }
        return tempArr;
    },



    /*
     * form[object]--原始表单
     * id[int]--修改对象id
     * str[string(str.)]--需要转换的参数前缀
     * allPara[object]--需要转多少个参数前缀
     * noPrefix[boolean]--转后的对象是否都有str.前缀(默认没有、不填写，和需要转的参数对比)
     */
    transform(form, id, str, allPara, noPrefix){
        var tempForm = {},
            tempArr = [];
        //获取key对象
        if(allPara){
            tempArr = Object.keys(allPara).map(function(item){
                return item.replace(str, '');
            });
        }
        //转换
        for(var key in form){
            var humpStr = key.replace(new RegExp(/(_[a-z])/g),function(a){return a.charAt(1).toUpperCase()}).replace(str, '');
            //过滤
            if(tempArr.indexOf(humpStr) >= 0 || tempArr.indexOf(key) >= 0){
                var prefix = str;
                if(!noPrefix && typeof allPara[humpStr] != 'undefined'){
                    prefix = '';
                }
                tempForm[prefix + humpStr] = form[key];
            }
        }
        //修改
        if(typeof id != 'undefined' && id != null){
            tempForm[str + 'id'] = id;
        }
        return tempForm;
    },
    transform2(form, id, str, allPara, noPrefix){
        var tempForm = {},
            tempArr = [];
        allPara = allPara || form;
        //获取key对象
        if(allPara){
            tempArr = Object.keys(allPara).map(function(item){
                return item.replace(str, '');
            });
        }
        //转换
        for(var key in form){
            var humpStr = key.replace(new RegExp(/(_[a-z])/g),function(a){return a.charAt(1).toUpperCase()}).replace(str, '');
            //过滤
            if(tempArr.indexOf(humpStr) >= 0 || tempArr.indexOf(key) >= 0){
                var prefix = str;
                if(!noPrefix && typeof allPara[humpStr] != 'undefined'){
                    prefix = '';
                }
                tempForm[prefix + humpStr] = form[key];
            }
        }
        //修改
        if(typeof id != 'undefined' && id != null){
            tempForm[str + 'id'] = id;
        }
        return tempForm;
    },

    //获取已有参数的对象
    /*
     * obj--现有对象
     * form--初始化参数对象
     * */
    getInitPara(obj = {}, form = {}){
        var tempForm = {};
        for(var i in obj){
            if(Object.keys(form).indexOf(i) >= 0){
                tempForm[i] = obj[i];
            }
        }
        return tempForm;
    },






    //循环列表的操作列表
    /*
     * arr--循环体数组
     * obj--操作对象
     * */
    handleLoopList(arr, obj){
        return arr.map(function(){
            return Object.assign({}, obj);
        });
    },

    //获取数组的index
    /*
     * arr--数组
     * para--需要查找的对象参数
     * value--找到对应的值
     * */
    getArrIndex(arr, para, value){
        let index = -1;
        arr.forEach(function(item, i){
            if(item[para] === value){
                index = i;
                return;
            }
        })
        return index;
    },
    //获取数组的对象和index
    /*
     * arr--数组
     * para--需要查找的对象参数
     * value--找到对应的值
     * */
    getArrObj(arr, para, value){
      let obj = null;
      arr.forEach(function(item, i){
        if(item[para] === value){
          obj = {
            index: i,
            item: item
          };
          return;
        }
      })
      return obj;
    },

    //图片上传使用---------------------------------------
    //获取未提交本地id
    /*
     * arr--上传列表数组
     * name--上传文件名称
     * */
    getUploadIndex(arr, name){
        let index = 0;
        for(let i=0;i<arr.length;i++){
            if(arr[i].name == name){
                index = i;
                break;
            }
        }
        return index;
    },
    //检测当前是否都上传成功
    /*
     * arr--上传列表数组
     * length--上传列表总长度
     * */
    inspectUpload(arr, len){
        let inspect = false;
        let isUndefined = false;
        for(let i=0;i<arr.length;i++){
            if(typeof arr[i] == 'undefined'){
                isUndefined = true;
                break;
            }
        }
        if(arr.length == len && !isUndefined){
            inspect = true;
        }
        return inspect;
    },



    //数组排序---------------------------------------
    //交换位置
    /*
     * arr--数组
     * oldIndex--旧index
     * newIndex--新index
     * */
    transpositionArr(arr, oldIndex, newIndex){
        var tempArr = arr.concat();
        tempArr[newIndex] = tempArr.splice(oldIndex, 1, tempArr[newIndex])[0];
        return tempArr;
    },
    //插入排序
    /*
     * arr--数组
     * oldIndex--旧index
     * newIndex--新index
     * */
    insertSortArr(arr, oldIndex, newIndex){
        let tempArr = arr.concat();
        tempArr.splice(newIndex, 0, tempArr.splice(oldIndex,1)[0]);
        return tempArr;
    },



    //临时处理新闻图片
    tempHandleImg(obj){
      $(obj).each(function(i, item){
        if(item.style.cssText.indexOf('text-indent') >= 0 && $(item).html().slice(0, 9).indexOf('<img src=') >= 0){
          item.style.cssText += 'text-indent: 0';
        };
      })
    },
    newsHandleImg(obj){
      var $content = $(obj),
          width = $content.width();
      $content.find('*').each(function(){
        var $this = $(this);
        if($this.innerWidth() > width){
          $this.innerWidth(width);
        }
        if($this[0].nodeName == 'IMG'){
          if($this.attr('data-width') > width || $this.attr('data-width') == '0'){
            $this.css({'width': '100%', 'height': 'auto'});
          }
          $this.css({'max-width': 'auto', 'min-width': 'auto', 'max-height': 'auto', 'min-height': 'auto'})
        }
      });
    },




    //接口请求失败模板---------------------------------------
    /*
     * "授权码不存在", 510
     * "授权码已过期", 511
     * "授权码已禁用", 512
     * 500是服务器异常
     * 501直接显示我给你的error信息
     * "授权码不存在，或者已过期", 513
     * "支付信息错误", 514
     * 授权header(func_state-0试用-1支付过)
     * code
     * */
    requestError(code){
        if(!code) return;
        this.$message({
            showClose: true,
            message: '出错了，请稍后再试',
            type: 'error'
        });
    },




    //滚动结束---------------------------------------
    /*
     * _this -- this
     * data -- 返回的数据结果（含参数total的）
     * list -- 缓存列表
     * paging -- 缓存页码等
     * */
    onEnd(_this, data, list = 'list', paging = 'paging'){
        _this[paging].count++;//监听成功滚动到底部
        _this[paging].cpi++;//页码+1
        if(data.total <= _this[list].length){
            //页码
            _this[paging].cpi = Math.ceil(data.total / _this[paging].cps);
            if(data.total % _this[paging].cps == 0){
                _this[paging].cpi++;//页码+1
            }
            _this[paging].end = true;//结束滚动
        }
    },



    //检测第一条---------------------------------------
    /*
     * _this -- this
     * url -- ajax请求的url
     * key -- 参数唯一识别（默认id）
     * para -- ajax请求的参数
     * list -- 缓存列表（data对象list）
     * callback -- 回调
     * */
    checkFirstAuthCode(_this, url, key = 'id', para = {pi: 1, ps: 1}, list = 'list', callback){
        let cb = callback || Array.prototype.slice.apply(arguments).filter(n => typeof n == 'function')[0];
        key = typeof key != 'function' ? key : 'id';
        para = typeof para != 'function' ? para : {pi: 1, ps: 1};
        list = typeof list != 'function' ? list : 'list';

        _this.$post(url, para).then(res => {
            let data = res.data;
            if(data.rows.length > 0){
                let obj = data.rows[0];
                if(_this[list].map(n => n[key]).indexOf(obj[key]) < 0){
                    _this[list].unshift(obj);
                }
            }

            //回调
            cb && cb();
        }, err=>{}).then(()=>{});
    },




    //修改列表详情---------------------------------------
    /*
     * _this -- this
     * url -- ajax请求的url
     * key -- 参数唯一识别（默认id）
     * list -- 缓存列表（data对象list）
     * callback -- 回调
     * */
    modifyListDetails(_this, url, key = 'id', list = 'list', callback){
        let cb = callback || Array.prototype.slice.apply(arguments).filter(n => typeof n == 'function')[0];
        key = typeof key != 'function' ? key : 'id';
        list = typeof list != 'function' ? list : 'list';

        let id = _this.$route.query.mid;
        if(id){
            let index = _this[list].map(n => n[key]).indexOf(id);
            if(index >= 0){
                _this.$post(url, {
                    pi: index + 1,
                    ps: 1
                }).then(res => {
                    let data = res.data;
                    if(data.rows.length > 0){
                        let obj = data.rows[0];
                        if(obj[key] == _this.list[index][key]){
                            for(let k in obj){
                                _this.list[index][k] = obj[k];
                            }
                        }
                    }

                    //回调
                    cb && cb();
                }, err=>{}).then(()=>{});
            }
        }
    },




    //缓存---------------------------------------
    /*
     * _this -- this
     * key -- vuex存储的key（state）
     * para -- 动态设置对象（data对象dynamicSetting）
     * list -- 缓存列表（data对象list）
     * paging -- 缓存页码等（data对象paging）
     * */
    outCache(_this, key, para = 'dynamicSetting', list = 'list', paging = 'paging'){
        $(window).off();

        //缓存
        _this[para].storage.list = _this[list];
        _this[para].storage.pi = _this[paging].cpi;
        _this[para].storage.total = _this[paging].total;
        _this[para].storage.top = _this[para].windowTop;

        _this.$store.commit(key, _this[para].storage);
    },
    initCache(_this, key, para = 'dynamicSetting', list = 'list', paging = 'paging'){
        //存储状态
        _this.$set(_this[para], 'storage', {});
        _this.$set(_this[para], 'windowTop', 0);

        if(_this.$state[key]){
            _this[para].storage = _this.$state[key];

            _this[paging].cpi = _this[para].storage.pi;
            _this[paging].total = _this[para].storage.total;
            _this[list] = [..._this[para].storage.list];

            _this.$nextTick(() => {
                $(window).scrollTop(_this[para].storage.top * 1);
            })
        }

        //top
        $(window).on('scroll', () => {
            _this[para].windowTop = $(window).scrollTop();
        })
    },
    //修改缓存
    modifyCache(_this, url, key, obj, para = {pi: 1, ps: 1}, callback){
        let cb = callback || Array.prototype.slice.apply(arguments).filter(n => typeof n == 'function')[0];
        para = typeof para != 'function' ? para : {pi: 1, ps: 1};

        let list = _this.$state[key.out] && _this.$state[key.out].list;
        //存在缓存
        if(list){
            //获取key,value
            let k = Object.keys(obj)[0];
            let v = Object.values(obj)[0];
            //获取index
            let index_list = list.map(n => n[k]).indexOf(v);
            if(index_list > -1){
                //pi等于index + 1
                para.pi = index_list + 1;
                para.ps = 1;
                //获取单个列表值
                _this.$post(url, para).then(res => {
                    let data = res.data;
                    if(data.rows.length > 0 && data.rows[0][k] == v){//存在并且值相等
                        let temp = JSON.parse(JSON.stringify(_this.$state[key.out]));
                        temp.list[index_list] = data.rows[0];
                        //替换缓存
                        _this.$store.commit(key.in, temp);
                    }

                    //回调
                    cb && cb();
                },err=>{}).then(()=>{})
                return;
            }

            //回调
            cb && cb();
            return;
        }
        //回调
        cb && cb();
    },


    /**
     * 判断访问终端
     */
    getBrowser(){
        //判断访问终端
        var browser = {
            versions:function(){
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                return {
                    trident: u.indexOf('Trident') > -1, //IE内核
                    presto: u.indexOf('Presto') > -1, //opera内核
                    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                    iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
                    iPad: u.indexOf('iPad') > -1, //是否iPad
                    webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                    weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                    qq: u.match(/\sQQ/i) == "qq" //是否QQ
                };
            }()
        }

        return browser;
    },

    // 校验规则
    /*
     * form -- 表单
     * rule -- 规则
     * isTip -- 是否提示默认true
     * */
    onRule(form, rule, isTip = true){
        var maxRatio = 1.6;
        var maxEm = 25;

        //是否错误
        var isError = false;

        for(var key in rule){
            var o = rule[key];
            var value = form[key];
            //必填
            if(o.required && (value === '' || typeof value === 'undefined' || value === null)){
                isTip && Vue.$vux.toast.show({
                    type: 'text',
                    position: 'top',
                    text: o.message,
                    width: (o.message.length * maxRatio < maxEm ? o.message.length * maxRatio : maxEm) + 'em'
                })
                isError = true;
                break;
            }
            //最小长度
            if(typeof o.minLength !== 'undefined' && (value && value.length < o.minLength.value)){
                isTip && Vue.$vux.toast.show({
                    type: 'text',
                    position: 'top',
                    text: o.minLength.message,
                    width: (o.minLength.message.length * maxRatio < maxEm ? o.minLength.message.length * maxRatio : maxEm) + 'em'
                })
                isError = true;
                break;
            }
            //最大长度
            if(typeof o.maxLength !== 'undefined' && (value && value.length > o.maxLength.value)){
                isTip && Vue.$vux.toast.show({
                    type: 'text',
                    position: 'top',
                    text: o.maxLength.message,
                    width: (o.maxLength.message.length * maxRatio < maxEm ? o.maxLength.message.length * maxRatio : maxEm) + 'em'
                })
                isError = true;
                break;
            }


            if(typeof o.type !== 'undefined' && value !== ''){
                //整数类型
                //非数值 - //正量
                if(o.type.value == 'number'){
                    value *= 1;
                    if(isNaN(value) || (o.type.isMustPlus && value < 0)){
                        isTip && Vue.$vux.toast.show({
                            type: 'text',
                            position: 'top',
                            text: o.type.message,
                            width: (o.type.message.length * maxRatio < maxEm ? o.type.message.length * maxRatio : maxEm) + 'em'
                        })
                        isError = true;
                        break;
                    }

                    //小数点
                    if(typeof o.numberPoint !== 'undefined'){
                        //前
                        if(typeof o.numberPoint.pre !== 'undefined' && (Math.floor(value) + '').length > o.numberPoint.pre.value){
                            isTip && Vue.$vux.toast.show({
                                type: 'text',
                                position: 'top',
                                text: o.numberPoint.pre.message,
                                width: (o.numberPoint.pre.message.length * maxRatio < maxEm ? o.numberPoint.pre.message.length * maxRatio : maxEm) + 'em'
                            })
                            isError = true;
                            break;
                        }
                        //后
                        var pointAfter = (value + '').split('.')[1];
                        if(typeof o.numberPoint.after !== 'undefined' && (pointAfter && pointAfter.length > o.numberPoint.after.value)){
                            isTip && Vue.$vux.toast.show({
                                type: 'text',
                                position: 'top',
                                text: o.numberPoint.after.message,
                                width: (o.numberPoint.after.message.length * maxRatio < maxEm ? o.numberPoint.after.message.length * maxRatio : maxEm) + 'em'
                            })
                            isError = true;
                            break;
                        }
                    }
                }
                //时间
                if(o.type.value === 'date'){
                    //最小时间
                    if(typeof o.type.min !== 'undefined'){
                        if(o.type.min.time && (value < o.type.min.time.format('yyyy-MM-dd')) || o.type.min.param && (value < form[o.type.min.param])){
                            isTip && Vue.$vux.toast.show({
                                type: 'text',
                                position: 'top',
                                text: o.type.min.message,
                                width: (o.type.min.message.length * maxRatio < maxEm ? o.type.min.message.length * maxRatio : maxEm) + 'em'
                            })
                            isError = true;
                            break;
                        }
                    }
                    //最大时间
                    if(typeof o.type.max != 'undefined'){

                    }
                }
            }

        }

        return isError;
    },

    //拨打电话
    callphone(tel){
        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            //IOS打电话
            bridge.callHandler('APP.makeCall', {'tel': tel});
        })

        //浏览器web
        if(!window.appType){
            window.location.href = 'tel:' + tel;
            return;
        }

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.makeCall && APP.makeCall(JSON.stringify({'tel': tel}))
        }
    },





    //APP交互
    callHandler(param){
        //$('body').append('window.appType:' + window.appType + '!');

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(param.key, param.param || {}, function responseCallback(responseData) {
                param.callback && param.callback(responseData);
            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP[param.key] && APP[param.key](JSON.stringify(param.param || {}));
        }
    },
    //APP返回上一级页面-------------------
    /*
     * url -- '#/ask_price'
     * fun -- 回调 字符串函数
     * */
    app_backPage(url, fun){
        //$('body').append('window.appType:' + window.appType + '!');

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.InitFunToPage', {'nextUrl': url, 'fun': fun, 'viewStatus': 'viewDidAppear'}, function responseCallback(responseData) {

            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.InitFunToPage && APP.InitFunToPage(JSON.stringify({'nextUrl': url, 'fun': fun, 'viewStatus': 'viewDidAppear'}))
        }
    },

    //APP-web  打开新页面跳转
    /*
     * url -- '/ask_price'
     * self -- 'this'
     * path -- { path: '/ask_price' }
     * param -- 参数
     * */
    urlCommon(url, self, path, param){
        let util = this;

        //$('body').append('window.appType:' + window.appType + '!');
        //走路由
        if(param && param.$router){
            util.watchPush(self, url);
            self.$router.push(path);
            return;
        }


        let testPath = self.$state.testPath || '';
        let _url = self.$state.domain + testPath + '/#' + url;
        let $t = '?';
        if(_url.indexOf('?') >= 0){
            $t = '&';
        }
        _url += $t + 'v=' + Math.ceil(Math.random()*99999999999);



        //浏览器web
        if(!window.appType){
            util.watchPush(self, _url);
            self.$router.push(path);
            return;
        }

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.UrlCommon', {'url': _url, 'target': '_blank'}, function responseCallback(responseData) {
                util.watchPush(self, url);
            })
        })


        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined'){
            APP.UrlCommon && APP.UrlCommon(JSON.stringify({'url': _url, 'target': '_blank'}))
            util.watchPush(self, url);
        }

    },


    //读取cookies
    getCookie(name)
    {
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");

        if(arr=document.cookie.match(reg))

            return unescape(arr[2]);
        else
            return null;
    },


    /*{
        key: 'APP.SystemBrowser',
        param: {'url': url},
        self: this
    }*/
    //APP download
    appDownload(opts){
        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(opts.key, opts.param || {}, function responseCallback(responseData) {
                opts.callback && opts.callback(responseData);
            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            let $android = opts.self.$state.appVersion.android;
            //console.log($android);
            APP.showUpdateDialog && APP.showUpdateDialog(JSON.stringify({'url': $android.url}));
            //APP && APP.showUpdateDialog(JSON.stringify({'forceUpdate': $android.forceUpdate,'log': $android.log,'versionName': $android.versionName, 'versionCode': $android.versionCode,'url': $android.url}));
        }
    },

    //JS登录成功后通知壳
    loginByJS(id){
        let param = {'user_id': id};

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.LoginByJS', param, function responseCallback(responseData) {

            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.LoginByJS && APP.LoginByJS(JSON.stringify(param))
        }
    },

    //JS登出成功后通知壳
    logoutByJS(id){
        let param = {'user_id': id};

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.LogoutByJS', param, function responseCallback(responseData) {

            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.LogoutByJS && APP.LogoutByJS(JSON.stringify(param))
        }
    },

    //请求来源信息有url跳到url
    getSource(callback){
        let param = null;

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.GetSource', function responseCallback(responseData) {
                param = responseData;
                //alert('param:' + param);
                if(param){
                    callback && callback(param);
                }
            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.GetSource && (param = APP.GetSource());
            //alert('param:' + param);
            if(param){
                callback && callback(param);
            }
        }
    },


    //js准备好了才能执行(注册)
    jsReady(callback){
        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.JSReady', function(data, responseCallback) {
                //console.log("JS Ready:", data)

                //responseCallback(data)
                callback && callback()
            })
        })

        //Android
        if(window.appType == 'Android') {
            APP.JSReady && APP.JSReady();
            callback && callback()
        }


        //pc
        if(!window.appType) {
            callback && callback()
        }
    },

    //获取tipDom
    getTipDom(opts, self){
        let util = this;
        if(typeof opts == 'string'){
            opts = JSON.parse(opts);
        }
        self.$vux.confirm.show({
            title: '消息提示',
            content: opts.title,
            confirmText: '查看',
            cancelText: '稍后再看',
            onConfirm (msg) {
                //alert(msg)
                let currentUrl = window.location.href ? ('/' + window.location.href.split('/#/')[1].split('?')[0]) : '';
                let backUrl = opts.url ? opts.url.split('?')[0] : '';
                if(currentUrl && backUrl && (currentUrl == backUrl)){
                    window.location.reload();
                }else{
                    util.urlCommon(opts.url, self, { path: opts.url });
                }
            }
        })
    },

    /**
     * 获取版本号信息
     */
    getVer(){
        let util = this;
        let ver = '';
        let browser = util.getBrowser();
        if(browser.versions.ios) ver = 'ios';
        if(browser.versions.android) ver = 'android';
        let obj = (Vue.prototype && Vue.prototype.$state && Vue.prototype.$state.appVersion && Vue.prototype.$state.appVersion[ver]) || {}
        return obj;
    },

    /**
     * 监听推送消息
     * @param self
     * @param url
     */
    watchPush(self, url){
        let util = this;
        //app已经打开，app推送一条信息给js
        //js准备好了
        //alert('准备执行jsReady函数！')
        util.jsReady(function(){
            //alert('js准备好了！')
            //注册信息
            let param = null;
            let lastUrl = '';
            let currentUrl = '';
            let backUrl = '';
            //alert('js准备好了');
            /**
             *
             * @param opts = {
                 *  "content_type": "BJ", //报价
                 *  "message_type": "MSG_TYPE_BJ",
                 *  "url": "/ask_price?type=1",
                 *  "title": "推送消息文字"
                 * }
             *
             */
            /*util.getAllWebViewURLs(function(urlArr){
                //
                lastUrl = urlArr[0] ? ('/' + urlArr[0].split('/#/')[1].split('?')[0]) : '';
                alert(lastUrl + '--' + url)
            });
            setTimeout(function(){
                alert(self.$route.path)
            }, 2000)*/
            //IOS
            window.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('APP.PushMessage', function(data, responseCallback) {
                    param = data;
                    //alert('APP.PushMessage:' + JSON.stringify(param));

                    /*util.getAllWebViewURLs(function(urlArr){
                        //
                        lastUrl = urlArr[0] ? ('/' + urlArr[0].split('/#/')[1].split('?')[0]) : '';
                        alert(lastUrl + '--' + url)
                    });*/
                    //util.getTipDom(param, self);
                    //console.log("JS Echo called with:", data)
                    responseCallback('PushMessage进入ios回调')
                })
            })

            //Android
            if(window.appType == 'Android' && typeof APP != 'undefined') {
                //alert('安卓去注册 “window.pushMessage” 函数')
                if(typeof window.pushMessage != 'function'){
                    window.pushMessage = function(data){
                        param = data;
                        if(typeof data == 'string') param = JSON.parse(data);
                        //alert('接下来要弹出提示！')
                        //util.getTipDom(param, self);
                    };
                }
            }

            //if(!window.appType) {
                /*$('#startPush').on('click', function(){
                    param = {
                        "content_type": "BJ", //报价
                        "message_type": "MSG_TYPE_BJ",
                        "url": "/ask_price?type=1",
                        "title": "推送消息文字"
                    };
                    //lastUrl = '/calculator';
                    alert(window.location.href)
                    //alert(lastUrl, url.split('?')[0]);
                    util.getTipDom(param, self);
                })*/
            //}
        });

        //每次请求app来源有url的话跳到来源url（一般是在app没有打开的情况下）需判断是否是当前url
        /*util.getSource((data)=>{
            alert('js.getSource:' + JSON.stringify(data))
            util.getTipDom(data, self);
            /!*return;
            let v = data;
            if(typeof data == 'object'){
                v = JSON.stringify(data);
            }
            alert(v);*!/
        })*/
    },

    getAllWebViewURLs(callback){
        let data = [];

        //IOS
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('APP.AllWebViewURLs', function responseCallback(responseData) {
                //alert(Array.isArray(responseData))
                //alert(typeof responseData)
                //alert(responseData);
                data = responseData;
                callback && callback(data);
            })
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            data = APP.AllWebViewURLs && APP.AllWebViewURLs();
            callback && callback(data);
        }
    },


    //APP.navigationBarRightButtons  app头部右上角
    /*
     * param.self -- 'this'
     * param.appFunName -- 按钮数组
     * param.prefix -- 方法名前缀
     * param.fun -- 本地方法名称默认appFun
     * */
    navigationBarRightButtons(param){
        let arr = [];
        for(let obj of param.appFunName){
            let funName = param.prefix + obj.key;
            //注册全局方法
            if(!window[funName]) {
                window[funName] = function () {
                    param.self[param.fun || 'appFun'](obj.key);
                }
            }
            obj['fun'] = param.prefix + obj.key + '()';
            arr.push(obj);
        }

        //ios
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(
                'APP.navigationBarRightButtons',
                arr,
                function responseCallback(responseData){

                }
            )
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP.navigationBarRightButtons && APP.navigationBarRightButtons(JSON.stringify(arr));
            callback && callback(arr);
        }
        /*window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(
                'APP.navigationBarRightButtons',
                [
                    {title: '审核', fun: 'sale_details_fun_examine()'},
                    {title: '修改', fun: 'sale_details_fun_modify()'},
                    {title: '更多', fun: 'sale_details_fun_more()', url: 'https://h5.boss.360leiliang.com/test_erp/icon/ellipsis.png', type: 'img'}
                ],
                function responseCallback(responseData){

                }
            )
        })*/
    },
    //APP.DownloadAndShareExcelFile  app通过url下载excel文件
    /**
     * 下载的url
     * 下载的回调函数
     * @param options
     */
    downloadAndShareExcelFile(url, callbackFunName){
        let fileUrl = url;
        let param = {
            'fileUrl': fileUrl,
            'callbackFunName': callbackFunName
        };
        //ios
        window.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(
                'APP.DownloadAndShareExcelFile',
                param,
                function responseCallback(responseData){
                    //callback && callback(responseData)
                }
            )
        })

        //Android
        if(window.appType == 'Android' && typeof APP != 'undefined') {
            APP && APP.DownloadAndShareExcelFile(JSON.stringify(param));
        }


        /*if(!window.DownloadAndShareExcelFile_callback){
            window.DownloadAndShareExcelFile_callback = function(res){
                $('#kkk').append('注册：' + JSON.stringify(res))
                //alert('注册：' + JSON.stringify(res))
                callback && callback(res);
            }
        }*/
    },

    /**
     * 注册JS函数给App调用
     * @param options
     */
    regJsFunForAppExecute(param){
        for(let obj of param.appFunName){
            let funName = param.prefix + obj.key;
            //注册全局方法
            if(!window[funName]){
                window[funName] = function () {
                    param.self[param.fun || 'appFun'](obj.key);
                }
            }
            obj['fun'] = param.prefix + obj.key + '()';
        }
    },

    //post下载文件
    postDownLoadFile(options) {
        var config = $.extend(true, { method: 'post' }, options);
        var $iframe = $('<iframe id="down-file-iframe" />');
        var $form = $('<form target="down-file-iframe" method="' + config.method + '" />');
        $form.attr('action', config.url);
        for (var key in config.data) {
            $form.append('<input type="hidden" name="' + key + '" value="' + config.data[key] + '" />');
        }
        $iframe.append($form);
        $(document.body).append($iframe);
        $form[0].submit();
        $iframe.remove();
    }
};
export default $util;



// WEBPACK FOOTER //
// ./src/common/js/util.js